import { ROUTES } from './routes.js';
import { PATHS_NAME } from '@shared/routers/consts/pathsName.js';
import { changePageMeta } from '@shared/routers/utils/changeMeta.js';
import { PROJECT_KEYS } from '@shared/constants/keys/keys.js';
import { GOOGLE_AUTH_ENABLED } from '@shared/constants/featureFlags.js';

import { createRouter, createWebHistory } from 'vue-router';
import store from '@shared/store/index.js';

const mainRouter = createRouter({
    history: createWebHistory(),
    routes: [
      ROUTES[PATHS_NAME.MAIN],
      ROUTES[PATHS_NAME.CALENDAR],
      ROUTES[PATHS_NAME.FORECASTERS],
      ROUTES[PATHS_NAME.FEEDBACK],
      ROUTES[PATHS_NAME.SIGNALS],
      ROUTES[PATHS_NAME.TWITTER_HYPE],
      ROUTES[PATHS_NAME.RULES.TERMS],
      ROUTES[PATHS_NAME.RULES.PRIVACY],
      ROUTES[PATHS_NAME.ARTICLES],
      ROUTES[PATHS_NAME.REDIRECT_ARTICLE],
      ROUTES[PATHS_NAME.USER.MAIN],
      ROUTES[PATHS_NAME.OTHER_USERS.MAIN],
      // Google-роуты подключаются только при включённом флаге (см. featureFlags.js)
      ...(GOOGLE_AUTH_ENABLED ? [ROUTES[PATHS_NAME.GOOGLE_LOGIN], ROUTES[PATHS_NAME.GOOGLE_LINK]] : []),
      ROUTES[PATHS_NAME.TELEGRAM_LOGIN],
      ROUTES[PATHS_NAME.TELEGRAM_LINK],
      ROUTES[PATHS_NAME.CONFIRM_EMAIL],
      ROUTES[PATHS_NAME.PENDING_CONFIRM_EMAIL],
      ROUTES[PATHS_NAME.RESET_PASS],
      ROUTES[PATHS_NAME.MAGIC_LINK_CONSUME],
      ROUTES[PATHS_NAME.SCANNER],
      ROUTES[PATHS_NAME.STOREROOM],
      ROUTES[PATHS_NAME.KNOWLEDGE_BASE],
      ROUTES[PATHS_NAME.POLYMARKET],
      ROUTES[PATHS_NAME.PORTFOLIOS],
      ROUTES[PATHS_NAME.NOT_FOUND],
    ]
});

  // -------------------------
  // Обработка ошибок чанков (ChunkLoadError)
  // -------------------------
  mainRouter.onError((error) => {
    const chunkLoadFailedPattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error?.message?.match(chunkLoadFailedPattern);

    if (isChunkLoadFailed) {
      console.warn('[Router] Ошибка загрузки чанка, перезагружаем страницу...');
      window.location.reload();
    }
  });

  // -------------------------
  // Защита маршрутов (auth guard)
  // -------------------------
  mainRouter.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    const accessToken = store.getters.getAccessToken;
    changePageMeta(to);

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!accessToken) {
        next({ name: PATHS_NAME.MAIN });
      } else {
        next();
      }
    } else {
      next();
    }
  });

  // -------------------------
  // Яндекс.Метрика
  // -------------------------
  mainRouter.afterEach((to) => {
    if (window.ym) {
      window.ym(PROJECT_KEYS.YANDEX_METRIKA_KEY, 'hit', to.fullPath);
    }
  });
export default mainRouter;
